// Initialize Google Analytics
// Set REACT_APP_GA_MEASUREMENT_ID in your .env file to enable

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const initGA = () => {
  // Only initialize if GA ID is provided
  if (!GA_MEASUREMENT_ID || GA_MEASUREMENT_ID === 'G-XXXXXXXXXX') {
    console.log('Google Analytics not configured. Set REACT_APP_GA_MEASUREMENT_ID in .env file to enable.');
    return;
  }

  // Check if GA is already initialized
  if (window.dataLayer && window.gtag) {
    return;
  }

  // Load GA script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  // Initialize dataLayer and gtag function
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    page_path: window.location.pathname,
  });

  console.log('Google Analytics initialised with ID:', GA_MEASUREMENT_ID);
};
